import React, { useCallback, useMemo, useState } from 'react';
import { SketchPicker } from 'react-color';
import { theme } from './theme';
import TextButton from '@wix/da-ds/pkg/Buttons/TextButton';
import throttle from 'lodash/throttle';
import { useTranslation } from 'react-i18next';

import s from './ColorPicker.scss';

export interface Props {
  onChange: (value) => void;
  onRemove: () => void;
  value: string;
}

const ColorPicker: React.FC<Props> = ({ onRemove, onChange, value }) => {
  const { t } = useTranslation('editor');
  const [color, setColor] = useState(undefined);
  const updateColor = useCallback(
    colorState => {
      colorState && colorState.hex && onChange && onChange(colorState.hex);
    },
    [onChange]
  );

  const throttledUpdateColor = useMemo(
    () =>
      throttle(
        c => {
          updateColor(c);
          setColor(c);
        },
        50,
        {
          leading: false,
        }
      ),
    [updateColor]
  );

  return (
    <div className={s['root']}>
      <TextButton
        size="small"
        variant="destructive-red"
        className={s['button']}
        onClick={onRemove}
      >
        {t('colorpicker.remove')}
      </TextButton>
      <SketchPicker
        width="300px"
        styles={theme}
        onChange={throttledUpdateColor}
        color={color}
        disableAlpha
      />
    </div>
  );
};
ColorPicker.displayName = 'ColorPicker';

export default ColorPicker;
